import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'boma-card-image',
  templateUrl: './card-image.component.html',
  styleUrls: ['./card-image.component.scss'],
})
export class CardImageComponent {
  @Input() title = 'Title';
  @Input() subTitle = 'Subtitle';
  @Input() image = '/assets/layout/images/stock/busy.jpg';
  @Input() styleClass = '/assets/layout/images/stock/busy.jpg';
  // @Input() label = "Button" // Add action button
}
